import React from 'react';
import { Title } from '../data/types';
import './TitleDetails.css';

interface Props {
  title: Title;
}

const DATE_FORMAT = new Intl.DateTimeFormat('en-SG', { year: 'numeric', month: 'short', day: 'numeric' });

export default function TitleDetails({ title }: Props) {
  const fields: [string, string][] = [
    ['Added to Watch', DATE_FORMAT.format(new Date(title.catalog_added_date))],
    ['Access', title.access_tier],
    ['Avg. completion', `${Math.round(title.avg_completion_rate * 100)}%`],
    ['Ads', title.is_ad_supported ? 'Ad-supported' : 'No ads'],
  ];

  return (
    <div className="title-details">
      <p className="title-details__label">Details</p>
      <dl className="title-details__list">
        {fields.map(([label, value]) => (
          <div key={label} className="title-details__row">
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
